<template>
  <v-navigation-drawer dark expand-on-hover absolute permanent right>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title mt-5 mb-5"
            >Audiences</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <template v-for="item in items">
        <v-list-item :key="item.id" @click="loadExercise(item.id)">
          <v-list-item-content>
            <v-list-item-title v-if="item.doc.title">{{
              item.doc.title
            }}</v-list-item-title>
            <v-list-item-title v-else>{{ item.id }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title mt-5 mb-5"
            >Audience Messages</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-for="item in audienceQuestions"
        :key="item.model"
        @click="loadQuestion(item)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.title }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title mt-5 mb-5"
            >Features / Benefits / Evidence</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item
        v-for="item in contentQuestions"
        :key="item.model"
        @click="loadQuestion(item)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.title }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "ResultsArchitectureBar",
  data: () => ({}),
  props: {
    items: {
      type: Array,
    },
    audienceQuestions: {
      type: Array,
      default: () => [],
    },
    contentQuestions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    loadExercise(val) {
      this.$emit("loadExercise", val);
    },
    loadQuestion(val) {
      this.$emit("loadQuestion", val);
    },
  },
};
</script>
